import styled from '@emotion/styled';
import { screenSizes } from 'src/assets/styles/Literals';

export const DashboardGroupsComponent = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #fafdff;
  border-radius: 20px;
  padding: 12px 16px 16px;

  @media (max-width: ${screenSizes.tablet}) {
    border-radius: 20px 20px 0 0;
    padding: 10px 12px 12px;
  }

  .groups-header {
    flex-shrink: 0;
  }

  .groups-heading-top {
    margin: 0;
    font-size: clamp(22px, 4vw, 35px);
    font-weight: 500;
  }

  .groups-heading-main {
    margin: 4px 0 0;
    color: #191919;
    font-size: clamp(28px, 5vw, 40px);
  }

  .groups-scroll {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
    padding-right: 2px;
    margin-right: -2px;
  }

  .groups-section-label {
    font-size: 18px;
    margin: 0 0 8px;
    color: #878787;

    &--spaced {
      margin-top: 20px;
    }
  }

  .group-card-title {
    font-size: clamp(20px, 4vw, 25px);
    font-weight: 600;
    color: #009700;
    margin: 0 0 6px;
    line-height: 1.25;
    word-break: break-word;
  }

  .group-card-leaders {
    margin: 0 0 14px;
    line-height: 1.45;
    word-break: break-word;
  }

  .columnsGroup {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;
    gap: 16px;
  }

  .link {
    color: #ff7f00;
  }

  .columnGroup {
    flex: 1;
    min-width: 0;
    padding: 12px;
    margin-right: 0;
  }

  .container-group-in {
    position: relative;
    border-radius: 12px;
    border: 1px solid #009700;
    background-color: #f5fef5;
    padding: 16px 18px;
    width: 50%;
    max-width: 100%;
    margin-bottom: 24px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.08);

    &.pending {
      background-color: #fef5f5;
      border-color: #ff0000;
    }

    .pending-banner {
      position: absolute;
      background-color: #ffffffbf;
      height: 100%;
      display: block;
      width: 100%;
      top: 0%;
      right: 0%;
      text-align: center;
    }
  }

  .group-meta-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    gap: 14px 20px;
    margin-top: 4px;
  }

  .group-meta-cell {
    flex: 1 1 140px;
    min-width: 0;
  }

  .group-meta-value {
    margin: 4px 0 0;
    line-height: 1.45;
    overflow-wrap: anywhere;
  }

  .container-group {
    padding: 0;
    max-width: 100%;
  }

  .subtitle {
    font-size: 17px;
    color: #a3a3a3;
    margin: 0;
    font-weight: 400;
  }

  .your-group {
    display: flex;
    width: 50%;
    max-width: 100%;
    flex-direction: column;
    gap: 12px;
  }

  .group-button {
    padding: 14px 16px;
    background: #191919;
    color: white;
    border: none;
    border-radius: 10px;
    cursor: pointer;
    text-align: left;
    line-height: 1.35;

    p {
      font-size: 15px;
      font-weight: 300;
      margin: 8px 0 0;
      opacity: 0.92;
    }

    &:hover {
      background: #232324;
    }
  }

  @media (max-width: ${screenSizes.tablet}) {
    .columnsGroup {
      flex-direction: column;
      align-items: stretch;
    }

    .columnGroup {
      padding: 8px 0;
      width: 100%;
    }

    .container-group-in {
      width: 100%;
      margin-bottom: 18px;
      padding: 18px 16px;
    }

    .group-meta-row {
      flex-direction: column;
      align-items: stretch;
      gap: 12px;
    }

    .group-meta-cell {
      flex: none;
      width: 100%;
    }

    .your-group {
      width: 100%;
    }

    .group-button {
      font-size: 16px;
      text-align: center;
      padding: 16px 18px;
    }
  }

  @media (max-width: ${screenSizes.mobile}) {
    .group-button {
      font-size: 17px;
      text-align: start;
      border-radius: 12px;
    }

    .subtitle {
      font-size: 15px;
    }

    .container-group-in {
      padding: 16px 14px;
    }
  }
`;
